import React from 'react'
import { Link } from 'react-router-dom'

import ClickableCard from '../layout/ClickableCard'
import * as dateUtils from '../../../libraries/date'
import type { Video } from '../../../api/videos/types'
import useScreenSize from '../../../hocs/useScreenSize'
import PlayIcon from '../../../assets/icons/play.svg?react'
import ProgressBar from './VideoProgressBar'
import VideoCardPreviewMedia from './VideoCardPreviewMedia'

type Props = { video: Video}
const ContinueWatchingVideoCard: React.FC<Props> = ({ video }) => {
  const screenSize = useScreenSize()
  const bgImage = screenSize.isMd ? video.thumbnailsUrls?.desktop : video.thumbnailsUrls?.mobileVertical
  const [cardHovered, setCardHovered] = React.useState(false)

  return (
    <ClickableCard>
      <div
        className='w-full h-[264px] sm:h-[364px] rounded-lg relative overflow-hidden'
        onMouseEnter={() => setCardHovered(true)}
        onMouseLeave={() => setCardHovered(false)}
      >
        <VideoCardPreviewMedia
          variant='fill'
          alt={video.title}
          posterSrc={bgImage}
          previewSrcUrl={video.previewUrl}
          cardHovered={cardHovered}
          className='rounded-lg'
        />
        <Link to={`/content/videos/${video.id}`} className='relative z-10 flex items-end h-full bg-gradient-to-t from-black/90 rounded-lg'>
          <div className='grid absolute h-full w-full place-items-center'><PlayIcon height={60} width={60}  /></div>
          <div className='px-3 py-6 md:px-6 md:py-6 text-white'>
            <div className='text-sm font-semibold line-clamp-2 md:line-clamp-1 truncate text-ellipsis text-wrap'>
              {video.title}
            </div>
            <div className='text-xs'>
              {dateUtils.parseSecondsToHoursAndMinutes(video.watchTime)} · {video.mainCategory.name}
            </div>
          </div>
        </Link>
        <div className='relative z-10 -translate-y-2 mx-3 md:mx-6'>
          <ProgressBar duration={video.watchTime} watched={video?.userActivity?.watched} currentPlayTime={video?.userActivity?.currentPlayTime} />
        </div>
      </div>
    </ClickableCard>
  )
}

export default ContinueWatchingVideoCard
